//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    fullWidth: {
      type: Boolean,
      default: true
    },
    video: {
      type: Object,
      required: true
    },
    willAutoplay: {
      type: Boolean,
      default: true
    },
    isMuted: {
      type: Boolean,
      default: true
    },
    willLoop: {
      type: Boolean,
      default: false
    },
    showControls: {
      type: Boolean,
      default: false
    },
    showPreview: {
      type: Boolean,
      default: true
    },
    transform: {
      type: Boolean,
      default: true
    },
    transformSizing: {
      type: String,
      default: '16x9_lg'
    },
    previewOptions: {
      type: Object,
      default: () => ({
        start: 0,
        duration: 1
      }),
      validator: (optionObject) => {
        return ((optionObject.start !== undefined && typeof optionObject.start === 'number') && (optionObject.duration !== undefined && typeof optionObject.duration === 'number'))
      }
    }
  },

  data () {
    return {
      hasPlayed: false,
      playing: false,
      observer: null,
      showPlayButton: false
    }
  },

  computed: {
    videoSrc () {
      return this.$video.transform(this.video.src, {
        transform: this.transform ? this.transformSizing : false,
        extraParams: this.isMuted ? 'ac_none' : ''
      })
    },
    previewVideoSrc () {
      const previewTrimParamsString = `ac_none,so_${this.previewOptions.start},du_${this.previewOptions.duration}`
      return this.$video.transform(this.video.src, {
        transform: this.transform ? this.transformSizing : false,
        extraParams: previewTrimParamsString
      })
    },
    poster () {
      // Remove file extension
      const url = this.videoSrc.split('.')
        .slice(0, -1)

      url.push('jpg')

      return url.join('.')
    }
  },

  created () {
    if (this.showControls) {
      this.showPlayButton = true
    }
  },

  mounted () {
    const target = this.$refs.video

    if (this.willAutoplay) {
      this.observer = new window.IntersectionObserver(
        ([entry]) =>
          entry.isIntersecting ? target.play() : target.pause(),
        {
          root: null,
          threshold: 0
        }
      )
      this.observer.observe(target)
    }
  },

  beforeDestroy () {
    if (this.observer) {
      this.observer.disconnect()
    }
  },

  methods: {
    togglePlayback () {
      if (this.playing) {
        this.$refs.video.pause()
        this.playing = false
        this.showPlayButton = true
        return
      }

      if (!this.hasPlayed) {
        this.hasPlayed = true
        // Disconect observer once user has interacted
        // with the video
        if (this.observer) {
          this.observer.disconnect()
        }
        this.$refs.video.currentTime = 0
      }

      if (!this.isMuted) {
        this.$refs.video.muted = false
      }

      this.showPlayButton = false
      this.$refs.video.play()
      this.playing = true
    }
  }
}
